import React from "react";
import { hydrateRoot } from "react-dom/client";
import App from "./App";
import "@fuzzybit-org/design-language/css";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Missing #root element");
}

hydrateRoot(
  rootElement,
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
